<template>
	<div class="box">
		<img class="rok" src="~@/assets/chengg.png" alt="">
		<div class="title-text">
			报名成功
		</div>
		<div class="tip-text">
			尊敬的学员:<br/>
			　　您好，欢迎加入中课网校，您订购的课程即将为您开通，请留意短信提醒。如您在学习过程中遇到问题请与我们联系: 400-8787-501，祝您学习愉快。
		</div>
		<div class="button-box">
			<van-button type="primary" round plain @click="$router.go(-1)">　　返　回　　</van-button>
		</div>
	</div>
</template>

<script>
	export default {}
</script>
<style>
	
</style>
<style lang="stylus" rel="stylesheet/stylus" scoped>
	.box{
		padding: 0.25rem;
		padding-top: 2rem;
		display: flex;
		align-items: center;
		flex-direction: column;
		.button-box{
			padding-top: 4rem;
			button{
				// background: #52c41a;
				border-color:#52c41a;
				color: #52c41a;
			}
		}
		.rok{
			width: 1.21rem;
			height: 1.21rem;
		}
		.title-text{
			font-size: 0.32rem;
			margin-top: 0.2rem;
		}
		.tip-text{
			border-top: 1px solid #cecece;
			margin-top: 1rem;
			padding-top: 0.5rem;
			font-size: 0.26rem;
			line-height: 1.8;
			color: #383838;
		}
	}
</style>